import React from 'react';
import styled from 'styled-components';

const Container = styled.section`
  background-color: #ededed;
  padding: 50px 0 40px;
  position: relative;
  z-index: 2;
  clear: both;
  
  @media (max-width: 479px) {
    padding: 10px 0 20px;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
`;

const Title = styled.h2`
  color: transparent;
  background: linear-gradient(0.5turn, #393939 1%, #2c67fe 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 46px;
  font-family: 'Geologica', Arial, sans-serif;
  line-height: 1.2;
  font-weight: 400;
  margin-bottom: 20px;
  
  @media (max-width: 960px) {
    font-size: 36px;
  }
  
  @media (max-width: 640px) {
    font-size: 32px;
  }
  
  @media (max-width: 479px) {
    font-size: 22px;
    margin-top: 10px;
  }
`;

const Description = styled.div`
  color: #3c3e45;
  font-size: 14px;
  font-family: 'Geologica', Arial, sans-serif;
  line-height: 1.55;
  max-width: 634px;
  margin-bottom: 40px;
  
  ul {
    margin-top: 10px;
    padding-left: 20px;
  }
  
  li {
    margin-bottom: 5px;
  }
  
  strong {
    font-weight: 600;
  }
  
  @media (max-width: 479px) {
    font-size: 12px;
    max-width: 295px;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

// Определяем отдельные компоненты для каждого типа карточек
const DarkGradientCard = styled.div`
  border-radius: 24px;
  padding: 30px;
  min-height: 261px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(0.854turn, #272727, #3f3f3f);
  color: #ffffff;
  border: none;
  
  @media (max-width: 960px) {
    min-height: 300px;
    padding: 20px;
  }
  
  @media (max-width: 479px) {
    min-height: auto;
    padding: 15px;
  }
`;

const BlueGradientCard = styled.div`
  border-radius: 24px;
  padding: 30px;
  min-height: 261px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(0.779turn, #38b9c8, #6d55e7);
  color: #ffffff;
  border: none;
  
  @media (max-width: 960px) {
    min-height: 300px;
    padding: 20px;
  }
  
  @media (max-width: 479px) {
    min-height: auto;
    padding: 15px;
  }
`;

const BorderCard = styled.div`
  border-radius: 24px;
  padding: 30px;
  min-height: 261px;
  display: flex;
  flex-direction: column;
  background-color: #f1f3f6;
  border: 1px solid #dae0e9;
  color: #1d1d1d;
  
  @media (max-width: 960px) {
    min-height: 300px;
    padding: 20px;
  }
  
  @media (max-width: 479px) {
    min-height: auto;
    padding: 15px;
  }
`;

const StatNumber = styled.div`
  font-size: 64px;
  font-weight: 200;
  line-height: 1;
  margin-bottom: 10px;
  
  @media (max-width: 960px) {
    font-size: 59px;
  }
  
  @media (max-width: 640px) {
    font-size: 46px;
  }
  
  @media (max-width: 479px) {
    font-size: 44px;
  }
`;

const StatLabel = styled.div`
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  opacity: 0.8;
  
  @media (max-width: 960px) {
    font-size: 13px;
  }
  
  @media (max-width: 479px) {
    font-size: 12px;
  }
`;

const CardTitle = styled.h3`
  font-size: 26px;
  font-weight: 200;
  line-height: 1;
  margin-bottom: 15px;
  
  @media (max-width: 960px) {
    font-size: 27px;
  }
  
  @media (max-width: 640px) {
    font-size: 26px;
  }
  
  @media (max-width: 479px) {
    font-size: 22px;
  }
`;

const CardText = styled.p`
  font-size: 13px;
  font-weight: 300;
  line-height: 1.5;
  opacity: 0.8;
  
  @media (max-width: 960px) {
    font-size: 13px;
  }
  
  @media (max-width: 479px) {
    font-size: 12px;
  }
`;

const AboutPage = () => {
  const stats = [
    {
      type: 'dark',
      number: '2014',
      label: 'год основания туристической компании «Максимум»'
    },
    {
      type: 'border',
      title: 'Начало истории',
      text: 'Мы организуем комбинированные туры, чтобы вы посетили несколько городов за одну поездку. С 2014 года мы дарим нашим клиентам яркие впечатления и безупречный сервис. Идеально подбираем туры для людей со средним уровнем дохода, чтобы отдых был качественным и доступным.'
    },
    {
      type: 'blue',
      title: '10.000+<br>клиентов',
      text: '<strong>Работаем с 2014 года.</strong> У нас есть все документы (Реестровый номер РТО), более <strong>125</strong> положительных отзывов на 2ГИС и <strong>10 000+</strong> довольных клиентов. 30% обращаются к нам повторно!'
    },
    {
      type: 'border',
      number: '4',
      label: 'Опытных менеджера всегда на связи с вами'
    },
    {
      type: 'dark',
      title: '24/7',
      text: 'На связи 24 часа 7 дней в неделю. Если нужно что-то поменять или у вас возник вопрос — мы всегда на подхвате.'
    },
    {
      type: 'border',
      title: 'Цель нашей команды',
      text: 'Максимум очень трепетно относимся к вам, нашим клиентам, чтобы вы чувствовали себя комфортно и безопасно при взаимодействии с нами.'
    }
  ];

  const renderCard = (stat, index) => {
    const commonProps = {
      key: index
    };

    // Выбираем тип карточки на основе поля type
    if (stat.type === 'dark') {
      return (
        <DarkGradientCard {...commonProps}>
          {stat.number && (
            <>
              <StatNumber>{stat.number}</StatNumber>
              <StatLabel>{stat.label}</StatLabel>
            </>
          )}
          {stat.title && (
            <>
              <CardTitle dangerouslySetInnerHTML={{ __html: stat.title }} />
              <CardText dangerouslySetInnerHTML={{ __html: stat.text }} />
            </>
          )}
        </DarkGradientCard>
      );
    } else if (stat.type === 'blue') {
      return (
        <BlueGradientCard {...commonProps}>
          {stat.number && (
            <>
              <StatNumber>{stat.number}</StatNumber>
              <StatLabel>{stat.label}</StatLabel>
            </>
          )}
          {stat.title && (
            <>
              <CardTitle dangerouslySetInnerHTML={{ __html: stat.title }} />
              <CardText dangerouslySetInnerHTML={{ __html: stat.text }} />
            </>
          )}
        </BlueGradientCard>
      );
    } else {
      return (
        <BorderCard {...commonProps}>
          {stat.number && (
            <>
              <StatNumber>{stat.number}</StatNumber>
              <StatLabel>{stat.label}</StatLabel>
            </>
          )}
          {stat.title && (
            <>
              <CardTitle dangerouslySetInnerHTML={{ __html: stat.title }} />
              <CardText dangerouslySetInnerHTML={{ __html: stat.text }} />
            </>
          )}
        </BorderCard>
      );
    }
  };

  return (
    <Container>
      <Content>
        <Title>О компании</Title>
        <Description>
          Мы знаем, что ключевой момент покупки — это доверие и исчерпывающие ответы.
          <ul>
            <li><strong>Грамотные и приятные менеджеры,</strong> которые найдут релевантное предложение именно под ваш запрос.</li>
            <li><strong>Скорость ответа</strong> Не заставим ждать и оперативно подберем тур именно для вас</li>
            <li><strong>Прозрачность:</strong> Весь процесс оформления дистанционно или с посещением офиса. Всегда на связи, если нужны изменения.</li>
          </ul>
        </Description>
        
        <StatsGrid>
          {stats.map((stat, index) => renderCard(stat, index))}
        </StatsGrid>
      </Content>
    </Container>
  );
};

export default AboutPage;